import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=12d423ce&scoped=true"
import script from "./loyalty.vue?vue&type=script&lang=js"
export * from "./loyalty.vue?vue&type=script&lang=js"
import style0 from "./loyalty.vue?vue&type=style&index=0&id=12d423ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d423ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d423ce')) {
      api.createRecord('12d423ce', component.options)
    } else {
      api.reload('12d423ce', component.options)
    }
    module.hot.accept("./loyalty.vue?vue&type=template&id=12d423ce&scoped=true", function () {
      api.rerender('12d423ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/loyalty.vue"
export default component.exports